// ####################################+################################################
// ################# THIS IS GENERATED FILE DO NOT TOUCH!!!!!!!!!!!!####################
// ####################################-################################################
import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core"

/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never }

export type AircraftEquipmentCategory = "Avionics" | "Conditioning" | "Connectivity"

export type AircraftEquipmentStatus =
  "Compliant" | "Inactive" | "Maintenance" | "Operational"

export type AircraftSource = "LEON" | "MANUAL"

export type AircraftSystemStatus =
  "Enrolled" | "Overdue" | "Suspended" | "Terminated" | "Unknown"

export type AircraftSystemType = "APU" | "Powerplant"

export type AirportSource = "LEON" | "MANUAL" | "PLATFORM"

export type AuditRecordEvent =
  | "aircraft_create"
  | "aircraft_crew_create"
  | "aircraft_crew_delete"
  | "aircraft_eq_create"
  | "aircraft_eq_delete"
  | "aircraft_eq_update"
  | "aircraft_kam_create"
  | "aircraft_kam_delete"
  | "aircraft_operator_create"
  | "aircraft_operator_delete"
  | "aircraft_owner_create"
  | "aircraft_owner_delete"
  | "aircraft_spec_create"
  | "aircraft_spec_update"
  | "aircraft_sys_create"
  | "aircraft_sys_update"
  | "aircraft_update"
  | "aircraft_visibility_update"
  | "airport_create"
  | "airport_override_create"
  | "airport_override_update"
  | "airport_update"
  | "crew_create"
  | "crew_update"
  | "integration_leon_incremental_sync_aborted"
  | "integration_leon_incremental_sync_ended"
  | "integration_leon_incremental_sync_error"
  | "integration_leon_incremental_sync_started"
  | "integration_leon_initial_sync_aborted"
  | "integration_leon_initial_sync_ended"
  | "integration_leon_initial_sync_error"
  | "integration_leon_initial_sync_item_error"
  | "integration_leon_initial_sync_item_recovered"
  | "integration_leon_initial_sync_message"
  | "integration_leon_initial_sync_started"
  | "integration_leon_token_connected"
  | "integration_leon_token_removed"
  | "invoice_category_create"
  | "invoice_category_delete"
  | "invoice_category_update"
  | "invoice_create"
  | "invoice_update"
  | "invoice_upload_create"
  | "invoice_upload_update"
  | "leg_create"
  | "leg_update"
  | "operator_create"
  | "operator_update"
  | "organization_update"
  | "owner_create"
  | "owner_update"
  | "trip_create"
  | "trip_update"

export type BaggageSpecificationInput = {
  units: BaggageUnit
  value: string
}

export type BaggageUnit = "cu_ft" | "cu_m" | "kg" | "lb" | "ph" | "sq_ft" | "sq_m"

export type CrewRole = "CPT" | "DH" | "FA" | "FO" | "FRL" | "OBS"

export type Currency = "AED" | "EUR" | "GBP" | "ILS" | "USD"

export type DataSource = "LEON" | "MANUAL"

export type DateInput = {
  /** YYYY-MM-DD */
  plaindate: string
  /** HH:MM:SS */
  plaintime: string
  /** IANA compatible zone name or use 'UTC' if you only need date and time */
  timezone: string
}

export type DateOptionFormat = "dd_mm_yyyy" | "dd_mmm_yyyy" | "mm_dd_yyyy" | "yyyy_mm_dd"

export type DecimapSeparatorFormat = "comma" | "dot"

export type DistanceSpecificationInput = {
  units: DistanceUnit
  value: string
}

export type DistanceUnit = "ft" | "km" | "m" | "mi" | "nm" | "sm" | "yd"

export type FileEntityType = "aircraft" | "invoice" | "organization" | "user"

export type FlightStatus = "CONFIRMED" | "OPPORTUNITY" | "OPTION"

export type FlightType =
  | "AIRCRAFT_REPOSITIONING"
  | "AMBULANCE"
  | "CARGO"
  | "FREQUENT_FLYER"
  | "HEAD"
  | "MISSION"
  | "OTHER"
  | "OWNER"
  | "OWNER_CHARTER"
  | "PAX"
  | "REGULAR_PAX_TRANSPORT"
  | "SIMULATOR"
  | "STATE"
  | "TECHNICAL"
  | "TRAINING"

export type FuelSpecificationInput = {
  units: FuelUnit
  value: string
}

export type FuelUnit = "impgal" | "kg" | "l" | "lb" | "mt" | "usgal"

export type InitialSystem = "EU" | "USA"

export type InvoiceDataSource = "DIRECTO" | "MANUAL" | "UPLOAD"

export type InvoiceDocumentKind = "CREDIT_NOTE" | "INVOICE" | "SUPPORTING"

export type InvoiceType = "LATE" | "REGULAR" | "UNKNOWN"

export type InvoiceUploadStatus = "APPROVED" | "AWAITING_REVIEW" | "CLASSIFYING"

export type LlmProvider = "anthropic" | "openai"

export type MutationAgentFileDeleteInput = {
  name: string
  organizationId: string
  threadId: string
}

export type MutationAgentFileUploadInput = {
  file: File
  name: string
  organizationId: string
  threadId: string
}

export type MutationAircraftAddCrewInput = {
  aircraftId: string
  crewId: string
  source: AircraftSource
}

export type MutationAircraftAddOperatorInput = {
  aircraftId: string
  operatorId: string
  source: AircraftSource
}

export type MutationAircraftAddOwnerInput = {
  aircraftId: string
  ownerId: string
  source: AircraftSource
}

export type MutationAircraftCreateInput = {
  category: string
  certificateExpirationDate?: string | null | undefined
  country: string
  files: Array<File>
  images?: Array<string> | null | undefined
  insuranceRenewalDate?: string | null | undefined
  locationId: string
  manufacturer: string
  model: string
  organizationId: string
  pax: string
  registrationExpirationDate?: string | null | undefined
  serial: string
  tail: string
  yom: string
  yor: string
}

export type MutationAircraftDocumentAddInput = {
  aircraftId: string
  aircraftSource: AircraftSource
  categoryId?: string | null | undefined
  file: File
  name: string
  organizationId: string
}

export type MutationAircraftEquipmentAddInput = {
  aircraftId: string
  category: AircraftEquipmentCategory
  installedAt?: string | null | undefined
  isVisible?: boolean | null | undefined
  manufacturer?: string | null | undefined
  model?: string | null | undefined
  name?: string | null | undefined
  notes?: string | null | undefined
  organizationId: string
  status: AircraftEquipmentStatus
  type?: string | null | undefined
}

export type MutationAircraftEquipmentRemoveInput = {
  aircraftId: string
  id: string
  organizationId: string
  source: AircraftSource
}

export type MutationAircraftEquipmentUpdateInput = {
  aircraftId: string
  category?: AircraftEquipmentCategory | null | undefined
  id: string
  installedAt?: string | null | undefined
  isVisible?: boolean | null | undefined
  manufacturer?: string | null | undefined
  model?: string | null | undefined
  name?: string | null | undefined
  notes?: string | null | undefined
  organizationId: string
  source: AircraftSource
  status?: AircraftEquipmentStatus | null | undefined
  type?: string | null | undefined
}

export type MutationAircraftRemoveCrewInput = {
  aircraftId: string
  crewId: string
  source: AircraftSource
}

export type MutationAircraftSetKeyAccountManagersInput = {
  aircraftId: string
  source: AircraftSource
  userIds: Array<string>
}

export type MutationAircraftSpecificationUpdateInput = {
  aircraftId: string
  baggageCapacity?: BaggageSpecificationInput | null | undefined
  cabinZones?: string | null | undefined
  ceiling?: DistanceSpecificationInput | null | undefined
  fuelCapacity?: FuelSpecificationInput | null | undefined
  hours?: string | null | undefined
  id: string
  landingDistance?: DistanceSpecificationInput | null | undefined
  landings?: string | null | undefined
  notes?: string | null | undefined
  organizationId: string
  range?: DistanceSpecificationInput | null | undefined
  source: AircraftSource
  speed?: SpeedSpecificationInput | null | undefined
  takeoffDistance?: DistanceSpecificationInput | null | undefined
  useDefaults?: boolean | null | undefined
}

export type MutationAircraftSwitchHiddenInput = {
  id: string
  isHidden: boolean
  organizationId: string
  source: AircraftSource
}

export type MutationAircraftSystemUpdateInput = {
  aircraftId: string
  contractReference?: string | null | undefined
  id: string
  name?: string | null | undefined
  notes?: string | null | undefined
  organizationId: string
  provider?: string | null | undefined
  registryCountry?: string | null | undefined
  source: AircraftSource
  status?: AircraftSystemStatus | null | undefined
  type: AircraftSystemType
}

export type MutationAircraftUpdateImagesInput = {
  id: string
  images: Array<string>
  organizationId: string
  source: AircraftSource
}

export type MutationAircraftUpdateInput = {
  category?: string | null | undefined
  certificateExpirationDate?: string | null | undefined
  country?: string | null | undefined
  equipmentNotes?: string | null | undefined
  id: string
  insuranceRenewalDate?: string | null | undefined
  locationId?: string | null | undefined
  manufacturer?: string | null | undefined
  model?: string | null | undefined
  organizationId: string
  pax?: string | null | undefined
  registrationExpirationDate?: string | null | undefined
  serial?: string | null | undefined
  source: AircraftSource
  tail?: string | null | undefined
  yom?: string | null | undefined
  yor?: string | null | undefined
}

export type MutationCrewCreateInput = {
  firstName: string
  info: string
  lastName: string
  organizationId: string
  primaryAircraftId: string
  role: CrewRole
}

export type MutationCrewUpdateInput = {
  firstName: string
  id: string
  info: string
  lastName: string
  organizationId: string
  primaryAircraftId: string
  role?: CrewRole | null | undefined
  source: AircraftSource
}

export type MutationFlightsOverrideInput = {
  flightStatusOverride?: FlightStatus | null | undefined
  flightTypeOverride?: FlightType | null | undefined
  id: string
  source: DataSource
}

export type MutationInvoiceUpdateInput = {
  categoryId?: string | null | undefined
  id: string
  legCode?: string | null | undefined
  organizationId: string
  vendor?: string | null | undefined
}

export type MutationInvoiceUploadAddInput = {
  file: File
  name: string
  organizationId: string
}

export type MutationInvoiceUploadApproveInput = {
  id: string
  organizationId: string
}

export type MutationLeonIntegrationConnectInput = {
  operatorId: string
  organizationId: string
  refreshToken: string
}

export type MutationLeonIntegrationInitialSyncInput = {
  /** Upper time boundary for the sync. Defaults to the end of the current year. */
  end?: DateInput | null | undefined
  organizationId: string
  /** Lower time boundary for the sync. Defaults to the start of the current year. */
  start?: DateInput | null | undefined
}

export type MutationLeonIntegrationRemoveInput = {
  organizationId: string
}

export type MutationLlmConfigurationCreateInput = {
  apiKey: string
  endpoint: string
  isDefault: boolean
  model: string
  name: string
  organizationId: string
  provider: LlmProvider
}

export type MutationLlmConfigurationDeleteInput = {
  id: string
  organizationId: string
}

export type MutationLlmConfigurationSetDefaultInput = {
  id: string
  organizationId: string
}

export type MutationLlmConfigurationUpdateInput = {
  apiKey?: string | null | undefined
  endpoint: string
  id: string
  model: string
  name: string
  organizationId: string
  provider: LlmProvider
}

export type MutationOperatorCreateInput = {
  name: string
  organizationId: string
}

export type MutationOperatorUpdateInput = {
  id: string
  name: string
  organizationId: string
  source: AircraftSource
}

export type MutationOrganizationInviteInput = {
  email: string
  name: string
  organizationId: string
  role: string
}

export type MutationOrganizationUpdateInput = {
  logo?: string | null | undefined
  name: string
  organizationId: string
  slug: string
}

export type MutationOwnerCreateInput = {
  name: string
  organizationId: string
}

export type MutationOwnerUpdateInput = {
  id: string
  name: string
  organizationId: string
}

export type MutationOwnerUpdateNotesInput = {
  id: string
  notes: string
  organizationId: string
}

export type MutationOwnerUpdateOnBoardRulesInput = {
  id: string
  onBoardCateringPolicy: string
  onBoardPassengerPolicy: string
  onBoardRuleForAlcohol?: string | null | undefined
  onBoardRuleForPets?: string | null | undefined
  onBoardRuleForSmoking?: string | null | undefined
  onBoardRuleForWeapons?: string | null | undefined
  organizationId: string
}

export type MutationOwnerUpdateServiceInput = {
  id: string
  organizationId: string
  serviceBedding: string
  serviceCatering: string
  serviceEntertainment: string
  serviceFlowers: string
  serviceFragrance: string
  serviceLighting: string
  servicePreferredCabinTemperature: string
}

export type MutationPresetsGetInput = {
  initial: InitialSystem
  organizationId: string
  userId?: string | null | undefined
}

export type MutationPresetsUpdateInput = {
  altitude?: DistanceUnit | null | undefined
  baggage?: BaggageUnit | null | undefined
  dateFormat?: DateOptionFormat | null | undefined
  decimalSeparator?: DecimapSeparatorFormat | null | undefined
  distance?: DistanceUnit | null | undefined
  fuel?: FuelUnit | null | undefined
  id: string
  initial?: InitialSystem | null | undefined
  organizationId: string
  pressure?: PressureUnit | null | undefined
  runway?: DistanceUnit | null | undefined
  speed?: SpeedUnit | null | undefined
  temperature?: TemperatureUnit | null | undefined
  thousandsSeparator?: ThousandsSeparatorFormat | null | undefined
  timeFormat?: TimeOptionFormat | null | undefined
  verticalRate?: SpeedUnit | null | undefined
  weight?: WeightUnit | null | undefined
}

export type MutationPublicFileUploadInput = {
  content?: string | null | undefined
  entity: FileEntityType
  file?: File | null | undefined
  name: string
  organizationId: string
}

export type MutationUserUpdateImageInput = {
  image?: string | null | undefined
  organizationId: string
}

export type PressureUnit = "bar" | "hpa" | "inhg" | "psi"

export type QueryAircraftByIdInput = {
  id: string
  organizationId: string
  source: AircraftSource
}

export type QueryAircraftByOrganizationInput = {
  includeHidden?: boolean | null | undefined
  organizationId: string
  sources: Array<AircraftSource>
}

export type QueryAircraftDocumentListInput = {
  aircraftId: string
  aircraftSource: AircraftSource
  organizationId: string
}

export type QueryAircraftEquipmentListInput = {
  aircraftId: string
  organizationId: string
  source: AircraftSource
}

export type QueryAircraftSpecificationInput = {
  aircraftId: string
  initial?: InitialSystem | null | undefined
  organizationId: string
  source: AircraftSource
}

export type QueryAircraftSystemByTypeInput = {
  aircraftId: string
  organizationId: string
  source: AircraftSource
  type: AircraftSystemType
}

export type QueryAirportGetByTermInput = {
  organizationId: string
  sources: Array<AirportSource>
  term: string
}

export type QueryCrewByOrganizationInput = {
  organizationId: string
  sources: Array<AircraftSource>
}

export type QueryDocumentCategoriesGetInput = {
  organizationId: string
}

export type QueryFlightsGetAnalyticsInput = {
  aircraftIds?: Array<string> | null | undefined
  dateRangeEnd: DateInput
  dateRangeStart: DateInput
  isCnl: boolean
}

export type QueryFlightsGetSummaryInput = {
  aircraftIds?: Array<string> | null | undefined
  arrivalIds?: Array<string> | null | undefined
  blockTimeMaxMinutes?: number | null | undefined
  blockTimeMinMinutes?: number | null | undefined
  dateRangeEnd: DateInput
  dateRangeStart: DateInput
  departureIds?: Array<string> | null | undefined
  distanceMax?: number | null | undefined
  distanceMin?: number | null | undefined
  flightStatuses?: Array<FlightStatus> | null | undefined
  isCnl: boolean
  status?: Array<FlightType> | null | undefined
  term?: string | null | undefined
}

export type QueryInvoiceCategoriesGetInput = {
  organizationId: string
}

export type QueryInvoiceLateListInput = {
  aircraftId?: string | null | undefined
  organizationId: string
  year: number
}

export type QueryInvoiceLegCodesInput = {
  aircraftId?: string | null | undefined
  month: number
  organizationId: string
  year: number
}

export type QueryInvoiceMonthInboxInput = {
  aircraftId?: string | null | undefined
  lateOnly?: boolean | null | undefined
  month: number
  organizationId: string
  year: number
}

export type QueryInvoiceMonthSummariesInput = {
  aircraftId?: string | null | undefined
  organizationId: string
  year: number
}

export type QueryInvoiceUploadListInput = {
  organizationId: string
}

export type QueryLeonIntegrationGetEventsInput = {
  limit: number
}

export type QueryLeonIntegrationGetTokenInput = {
  organizationId: string
}

export type QueryLlmConfigurationsInput = {
  organizationId: string
}

export type QueryOperatorByOrganizationInput = {
  organizationId: string
  sources: Array<AircraftSource>
}

export type QueryOrganizationUsersInput = {
  organizationId: string
}

export type QueryOwnerByOrganizationInput = {
  organizationId: string
}

export type SpeedSpecificationInput = {
  units: SpeedUnit
  value: string
}

export type SpeedUnit = "M" | "fpm" | "kmh" | "kts" | "mph" | "mpm" | "nmh"

export type SubscriptionEventType =
  | "aircraft_create"
  | "aircraft_crew_create"
  | "aircraft_crew_delete"
  | "aircraft_eq_create"
  | "aircraft_eq_delete"
  | "aircraft_eq_update"
  | "aircraft_kam_create"
  | "aircraft_kam_delete"
  | "aircraft_operator_create"
  | "aircraft_operator_delete"
  | "aircraft_owner_create"
  | "aircraft_owner_delete"
  | "aircraft_spec_create"
  | "aircraft_spec_update"
  | "aircraft_sys_create"
  | "aircraft_sys_update"
  | "aircraft_update"
  | "aircraft_visibility_update"
  | "airport_create"
  | "airport_override_create"
  | "airport_override_update"
  | "airport_update"
  | "crew_create"
  | "crew_update"
  | "heartbeat"
  | "integration_leon_incremental_sync_aborted"
  | "integration_leon_incremental_sync_ended"
  | "integration_leon_incremental_sync_error"
  | "integration_leon_incremental_sync_started"
  | "integration_leon_initial_sync_aborted"
  | "integration_leon_initial_sync_ended"
  | "integration_leon_initial_sync_error"
  | "integration_leon_initial_sync_item_error"
  | "integration_leon_initial_sync_item_recovered"
  | "integration_leon_initial_sync_message"
  | "integration_leon_initial_sync_started"
  | "integration_leon_token_connected"
  | "integration_leon_token_removed"
  | "invoice_category_create"
  | "invoice_category_delete"
  | "invoice_category_update"
  | "invoice_create"
  | "invoice_update"
  | "invoice_upload_create"
  | "invoice_upload_update"
  | "leg_create"
  | "leg_update"
  | "operator_create"
  | "operator_update"
  | "organization_update"
  | "owner_create"
  | "owner_update"
  | "trip_create"
  | "trip_update"

export type TemperatureUnit = "c" | "f"

export type ThousandsSeparatorFormat = "comma" | "dot" | "none" | "space"

export type TimeOptionFormat = "TWELVE_HOUR" | "TWENTY_FOUR_HOUR"

export type WeightUnit = "kg" | "lb"

export type AircraftCategoriesQueryVariables = Exact<{ [key: string]: never }>

export type AircraftCategoriesQuery = { aircraftCategories: Array<string> }

export type AirportGetByTermQueryVariables = Exact<{
  input: QueryAirportGetByTermInput
}>

export type AirportGetByTermQuery = {
  airportGetByTerm: Array<{
    id: string
    source: AirportSource
    name: string
    code: string
    country: string
    city: string
    tz: string
  }>
}

export type CrewByOrganizationSelectQueryVariables = Exact<{
  input: QueryCrewByOrganizationInput
}>

export type CrewByOrganizationSelectQuery = {
  crewByOrganization: Array<{
    id: string
    source: AircraftSource
    firstName: string
    lastName: string
    role: CrewRole | null
  }>
}

export type OperatorByOrganizationQueryVariables = Exact<{
  input: QueryOperatorByOrganizationInput
}>

export type OperatorByOrganizationQuery = {
  operatorByOrganization: Array<{ id: string; source: AircraftSource; name: string }>
}

export type OwnerByOrganizationQueryVariables = Exact<{
  input: QueryOwnerByOrganizationInput
}>

export type OwnerByOrganizationQuery = {
  ownerByOrganization: Array<{ id: string; name: string }>
}

export type OrganizationUsersQueryVariables = Exact<{ [key: string]: never }>

export type OrganizationUsersQuery = {
  users: Array<{ id: string; name: string; image: string | null; role: Array<string> }>
}

export type GlobalSearchQueryVariables = Exact<{
  term: string
}>

export type GlobalSearchQuery = {
  search: {
    aircraft: Array<{
      id: string
      source: AircraftSource
      tail: string
      manufacturer: string
      model: string
      serial: string
      images: Array<string>
    }>
  }
}

export type LlmConfigurationsPageQueryVariables = Exact<{
  input: QueryLlmConfigurationsInput
}>

export type LlmConfigurationsPageQuery = {
  llmConfigurations: Array<{
    id: string
    name: string
    provider: LlmProvider
    endpoint: string
    model: string
    apiKeyLast4: string
    isDefault: boolean
  }>
}

export type LlmConfigurationCreateMutationVariables = Exact<{
  input: MutationLlmConfigurationCreateInput
}>

export type LlmConfigurationCreateMutation = { llmConfigurationCreate: { id: string } }

export type LlmConfigurationUpdateMutationVariables = Exact<{
  input: MutationLlmConfigurationUpdateInput
}>

export type LlmConfigurationUpdateMutation = { llmConfigurationUpdate: { id: string } }

export type LlmConfigurationSetDefaultMutationVariables = Exact<{
  input: MutationLlmConfigurationSetDefaultInput
}>

export type LlmConfigurationSetDefaultMutation = {
  llmConfigurationSetDefault: { id: string }
}

export type LlmConfigurationDeleteMutationVariables = Exact<{
  input: MutationLlmConfigurationDeleteInput
}>

export type LlmConfigurationDeleteMutation = { llmConfigurationDelete: boolean }

export type AircraftSettingsListQueryVariables = Exact<{
  input: QueryAircraftByOrganizationInput
}>

export type AircraftSettingsListQuery = {
  aircraftByOrganization: Array<{
    id: string
    source: AircraftSource
    tail: string
    manufacturer: string
    model: string
    serial: string
    isHidden: boolean
  }>
}

export type AircraftSwitchHiddenMutationVariables = Exact<{
  input: MutationAircraftSwitchHiddenInput
}>

export type AircraftSwitchHiddenMutation = { aircraftSwitchHidden: boolean }

export type CrewByOrganizationPageQueryVariables = Exact<{
  input: QueryCrewByOrganizationInput
}>

export type CrewByOrganizationPageQuery = {
  crewByOrganization: Array<{
    id: string
    source: AircraftSource
    firstName: string
    lastName: string
    role: CrewRole | null
    positions: Array<string>
    info: string
    primaryAircraftId: string
    primaryAircraft: { id: string; source: AircraftSource; tail: string } | null
  }>
}

export type CrewCreateMutationVariables = Exact<{
  input: MutationCrewCreateInput
}>

export type CrewCreateMutation = {
  crewCreate: {
    id: string
    source: AircraftSource
    firstName: string
    lastName: string
    role: CrewRole | null
  }
}

export type CrewUpdateMutationVariables = Exact<{
  input: MutationCrewUpdateInput
}>

export type CrewUpdateMutation = {
  crewUpdate: {
    id: string
    source: AircraftSource
    firstName: string
    lastName: string
    role: CrewRole | null
  }
}

export type OperatorsByOrganizationPageQueryVariables = Exact<{
  input: QueryOperatorByOrganizationInput
}>

export type OperatorsByOrganizationPageQuery = {
  operatorByOrganization: Array<{ id: string; source: AircraftSource; name: string }>
}

export type OperatorCreateMutationVariables = Exact<{
  input: MutationOperatorCreateInput
}>

export type OperatorCreateMutation = {
  operatorCreate: { id: string; source: AircraftSource; name: string }
}

export type OperatorUpdateMutationVariables = Exact<{
  input: MutationOperatorUpdateInput
}>

export type OperatorUpdateMutation = {
  operatorUpdate: { id: string; source: AircraftSource; name: string }
}

export type OwnerUpdateOnBoardRulesMutationVariables = Exact<{
  input: MutationOwnerUpdateOnBoardRulesInput
}>

export type OwnerUpdateOnBoardRulesMutation = { ownerUpdateOnBoardRules: { id: string } }

export type OwnerUpdateServiceMutationVariables = Exact<{
  input: MutationOwnerUpdateServiceInput
}>

export type OwnerUpdateServiceMutation = { ownerUpdateService: { id: string } }

export type OwnerUpdateNotesMutationVariables = Exact<{
  input: MutationOwnerUpdateNotesInput
}>

export type OwnerUpdateNotesMutation = { ownerUpdateNotes: { id: string } }

export type OwnersByOrganizationPageQueryVariables = Exact<{
  input: QueryOwnerByOrganizationInput
}>

export type OwnersByOrganizationPageQuery = {
  ownerByOrganization: Array<{
    id: string
    name: string
    onBoardRuleForPets: string | null
    onBoardRuleForAlcohol: string | null
    onBoardRuleForSmoking: string | null
    onBoardRuleForWeapons: string | null
    onBoardCateringPolicy: string
    onBoardPassengerPolicy: string
    servicePreferredCabinTemperature: string
    serviceFlowers: string
    serviceBedding: string
    serviceEntertainment: string
    serviceFragrance: string
    serviceCatering: string
    serviceLighting: string
    notes: string
  }>
}

export type OwnerCreateMutationVariables = Exact<{
  input: MutationOwnerCreateInput
}>

export type OwnerCreateMutation = { ownerCreate: { id: string; name: string } }

export type OwnerUpdateMutationVariables = Exact<{
  input: MutationOwnerUpdateInput
}>

export type OwnerUpdateMutation = { ownerUpdate: { id: string; name: string } }

export type AgentFileUploadMutationVariables = Exact<{
  input: MutationAgentFileUploadInput
}>

export type AgentFileUploadMutation = {
  agentFileUpload: {
    id: string
    name: string
    mimeType: string
    size: number
    source: string
    createdAt: string
  }
}

export type AgentFileDeleteMutationVariables = Exact<{
  input: MutationAgentFileDeleteInput
}>

export type AgentFileDeleteMutation = { agentFileDelete: boolean }

export type OrganizationMembersQueryVariables = Exact<{
  input: QueryOrganizationUsersInput
}>

export type OrganizationMembersQuery = {
  organizationUsers: Array<{
    id: string
    name: string
    email: string
    role: Array<string>
    image: string | null
    createdAt: string
  }>
}

export type OrganizationInviteMutationVariables = Exact<{
  input: MutationOrganizationInviteInput
}>

export type OrganizationInviteMutation = { organizationInvite: boolean }

export type DashboardFleetCountQueryVariables = Exact<{
  input: QueryAircraftByOrganizationInput
}>

export type DashboardFleetCountQuery = { aircraftByOrganization: Array<{ id: string }> }

export type AircraftByIdQueryVariables = Exact<{
  input: QueryAircraftByIdInput
}>

export type AircraftByIdQuery = {
  aircraftById: {
    id: string
    source: AircraftSource
    tail: string
    manufacturer: string
    model: string
    serial: string
    yom: string
    yor: string
    category: string
    pax: string
    images: Array<string>
    keyAccountManagers: Array<{ id: string; name: string; image: string | null }>
    operators: Array<{ id: string; source: AircraftSource; name: string }>
    owners: Array<{ id: string; name: string }> | null
  }
}

export type PublicFileUploadMutationVariables = Exact<{
  input: MutationPublicFileUploadInput
}>

export type PublicFileUploadMutation = { publicFileUpload: string }

export type AircraftUpdateImagesMutationVariables = Exact<{
  input: MutationAircraftUpdateImagesInput
}>

export type AircraftUpdateImagesMutation = {
  aircraftUpdateImages: { id: string; images: Array<string> }
}

export type AircraftSetKeyAccountManagersMutationVariables = Exact<{
  input: MutationAircraftSetKeyAccountManagersInput
}>

export type AircraftSetKeyAccountManagersMutation = {
  aircraftSetKeyAccountManagers: boolean
}

export type AircraftAddOperatorMutationVariables = Exact<{
  input: MutationAircraftAddOperatorInput
}>

export type AircraftAddOperatorMutation = { aircraftAddOperator: boolean }

export type AircraftAddOwnerMutationVariables = Exact<{
  input: MutationAircraftAddOwnerInput
}>

export type AircraftAddOwnerMutation = { aircraftAddOwner: boolean }

export type AircraftDocumentAddMutationVariables = Exact<{
  input: MutationAircraftDocumentAddInput
}>

export type AircraftDocumentAddMutation = { aircraftDocumentAdd: { id: string } }

export type DocumentCategoriesGetQueryVariables = Exact<{
  input: QueryDocumentCategoriesGetInput
}>

export type DocumentCategoriesGetQuery = {
  documentCategoriesGet: Array<{
    id: string
    parentId: string | null
    name: string
    critical: boolean
    sortOrder: number
  }>
}

export type AircraftDocumentListQueryVariables = Exact<{
  input: QueryAircraftDocumentListInput
}>

export type AircraftDocumentListQuery = {
  aircraftDocumentList: Array<{
    id: string
    categoryId: string | null
    name: string
    originalName: string
    mimeType: string
    size: number
    effectiveDate: string | null
    expiryDate: string | null
    createdAt: string
    createdByUser: { name: string } | null
  }>
}

export type AircraftEquipmentAddMutationVariables = Exact<{
  input: MutationAircraftEquipmentAddInput
}>

export type AircraftEquipmentAddMutation = {
  aircraftEquipmentAdd: {
    id: string
    type: string
    category: AircraftEquipmentCategory
    name: string
    manufacturer: string
    model: string
    status: AircraftEquipmentStatus
    installedAt: string
    isVisible: boolean
  }
}

export type AircraftSpecificationQueryVariables = Exact<{
  input: QueryAircraftSpecificationInput
}>

export type AircraftSpecificationQuery = {
  aircraftSpecification: {
    id: string
    aircraftId: string
    useDefaults: boolean
    hours: string | null
    landings: string | null
    cabinZones: string | null
    range: { value: string; units: DistanceUnit }
    speed: { value: string; units: SpeedUnit }
    ceiling: { value: string; units: DistanceUnit }
    takeoffDistance: { value: string; units: DistanceUnit }
    landingDistance: { value: string; units: DistanceUnit }
    fuelCapacity: { value: string; units: FuelUnit }
    baggageCapacity: { value: string; units: BaggageUnit }
  }
}

export type AircraftEquipmentListCardQueryVariables = Exact<{
  input: QueryAircraftEquipmentListInput
}>

export type AircraftEquipmentListCardQuery = {
  aircraftEquipmentList: Array<{
    id: string
    type: string
    category: AircraftEquipmentCategory
    name: string
    status: AircraftEquipmentStatus
    isVisible: boolean
  }>
}

export type CrewCreateModalMutationVariables = Exact<{
  input: MutationCrewCreateInput
}>

export type CrewCreateModalMutation = { crewCreate: { id: string } }

export type AircraftAddCrewModalMutationVariables = Exact<{
  input: MutationAircraftAddCrewInput
}>

export type AircraftAddCrewModalMutation = { aircraftAddCrew: boolean }

export type AircraftRemoveCrewModalMutationVariables = Exact<{
  input: MutationAircraftRemoveCrewInput
}>

export type AircraftRemoveCrewModalMutation = { aircraftRemoveCrew: boolean }

export type AircraftSpecificationUpdateMutationVariables = Exact<{
  input: MutationAircraftSpecificationUpdateInput
}>

export type AircraftSpecificationUpdateMutation = {
  aircraftSpecificationUpdate: {
    id: string
    aircraftId: string
    useDefaults: boolean
    hours: string | null
    landings: string | null
    cabinZones: string | null
    range: { value: string; units: DistanceUnit }
    speed: { value: string; units: SpeedUnit }
    ceiling: { value: string; units: DistanceUnit }
    takeoffDistance: { value: string; units: DistanceUnit }
    landingDistance: { value: string; units: DistanceUnit }
    fuelCapacity: { value: string; units: FuelUnit }
    baggageCapacity: { value: string; units: BaggageUnit }
  }
}

export type AircraftEquipmentListQueryVariables = Exact<{
  input: QueryAircraftEquipmentListInput
}>

export type AircraftEquipmentListQuery = {
  aircraftEquipmentList: Array<{
    id: string
    aircraftId: string
    type: string
    category: AircraftEquipmentCategory
    name: string
    manufacturer: string
    model: string
    status: AircraftEquipmentStatus
    installedAt: string
    isVisible: boolean
  }>
}

export type AircraftEquipmentNotesQueryVariables = Exact<{
  input: QueryAircraftByIdInput
}>

export type AircraftEquipmentNotesQuery = {
  aircraftById: { id: string; equipmentNotes: string }
}

export type AircraftEquipmentUpdateMutationVariables = Exact<{
  input: MutationAircraftEquipmentUpdateInput
}>

export type AircraftEquipmentUpdateMutation = {
  aircraftEquipmentUpdate: {
    id: string
    manufacturer: string
    model: string
    status: AircraftEquipmentStatus
    installedAt: string
  }
}

export type AircraftEquipmentRemoveMutationVariables = Exact<{
  input: MutationAircraftEquipmentRemoveInput
}>

export type AircraftEquipmentRemoveMutation = { aircraftEquipmentRemove: { id: string } }

export type AircraftUpdateEquipmentNotesMutationVariables = Exact<{
  input: MutationAircraftUpdateInput
}>

export type AircraftUpdateEquipmentNotesMutation = {
  aircraftUpdate: { id: string; equipmentNotes: string }
}

export type AircraftAddOwnerOwnershipMutationVariables = Exact<{
  input: MutationAircraftAddOwnerInput
}>

export type AircraftAddOwnerOwnershipMutation = { aircraftAddOwner: boolean }

export type AircraftAddOperatorOwnershipMutationVariables = Exact<{
  input: MutationAircraftAddOperatorInput
}>

export type AircraftAddOperatorOwnershipMutation = { aircraftAddOperator: boolean }

export type AircraftSetKamsOwnershipMutationVariables = Exact<{
  input: MutationAircraftSetKeyAccountManagersInput
}>

export type AircraftSetKamsOwnershipMutation = { aircraftSetKeyAccountManagers: boolean }

export type AircraftUpdateDatesMutationVariables = Exact<{
  input: MutationAircraftUpdateInput
}>

export type AircraftUpdateDatesMutation = {
  aircraftUpdate: {
    id: string
    certificateExpirationDate: string | null
    registrationExpirationDate: string | null
    insuranceRenewalDate: string | null
  }
}

export type PowerplantSystemsQueryVariables = Exact<{
  ppInput: QueryAircraftSystemByTypeInput
  apuInput: QueryAircraftSystemByTypeInput
}>

export type PowerplantSystemsQuery = {
  powerplant: {
    id: string
    type: AircraftSystemType
    name: string
    provider: string
    registryCountry: string
    status: AircraftSystemStatus
    contractReference: string
  }
  apu: {
    id: string
    type: AircraftSystemType
    name: string
    provider: string
    registryCountry: string
    status: AircraftSystemStatus
    contractReference: string
  }
}

export type AircraftSystemUpdatePpMutationVariables = Exact<{
  input: MutationAircraftSystemUpdateInput
}>

export type AircraftSystemUpdatePpMutation = {
  aircraftSystemUpdate: {
    id: string
    name: string
    provider: string
    registryCountry: string
    status: AircraftSystemStatus
    contractReference: string
  }
}

export type AircraftByIdGeneralInfoQueryVariables = Exact<{
  input: QueryAircraftByIdInput
}>

export type AircraftByIdGeneralInfoQuery = {
  aircraftById: {
    id: string
    source: AircraftSource
    tail: string
    manufacturer: string
    model: string
    serial: string
    yom: string
    yor: string
    country: string
    category: string
    locationId: string
    pax: string
    location: { id: string; source: AirportSource; city: string; code: string } | null
    crew: Array<{
      id: string
      source: AircraftSource
      firstName: string
      lastName: string
      role: CrewRole | null
    }>
  }
}

export type AircraftByIdOwnerPreferencesQueryVariables = Exact<{
  input: QueryAircraftByIdInput
}>

export type AircraftByIdOwnerPreferencesQuery = {
  aircraftById: {
    id: string
    owners: Array<{
      id: string
      name: string
      onBoardRuleForPets: string | null
      onBoardRuleForAlcohol: string | null
      onBoardRuleForSmoking: string | null
      onBoardRuleForWeapons: string | null
      onBoardCateringPolicy: string
      onBoardPassengerPolicy: string
      servicePreferredCabinTemperature: string
      serviceFlowers: string
      serviceBedding: string
      serviceEntertainment: string
      serviceFragrance: string
      serviceCatering: string
      serviceLighting: string
      notes: string
    }> | null
  }
}

export type AircraftByIdOwnershipQueryVariables = Exact<{
  input: QueryAircraftByIdInput
}>

export type AircraftByIdOwnershipQuery = {
  aircraftById: {
    id: string
    certificateExpirationDate: string | null
    registrationExpirationDate: string | null
    insuranceRenewalDate: string | null
    updatedAt: string
    updatedByUser: { id: string; name: string; image: string | null } | null
    owners: Array<{ id: string; name: string }> | null
    operators: Array<{ id: string; name: string }>
    keyAccountManagers: Array<{ id: string; name: string; image: string | null }>
  }
}

export type PowerplantCardQueryVariables = Exact<{
  ppInput: QueryAircraftSystemByTypeInput
  apuInput: QueryAircraftSystemByTypeInput
}>

export type PowerplantCardQuery = {
  powerplant: { id: string; name: string; provider: string; status: AircraftSystemStatus }
  apu: { id: string; name: string; provider: string; status: AircraftSystemStatus }
}

export type AuditGetCardQueryVariables = Exact<{
  events?: Array<AuditRecordEvent> | AuditRecordEvent | null | undefined
  source?: string | null | undefined
  parentId?: string | null | undefined
  first?: number | null | undefined
}>

export type AuditGetCardQuery = {
  auditGet: {
    edges: Array<{
      node: {
        id: number
        event: AuditRecordEvent
        entityId: string
        field: string
        before: string
        after: string
        user: { id: string; name: string } | null
        time: { milliseconds: string }
      }
    }>
  }
}

export type AuditGetPageQueryVariables = Exact<{
  events?: Array<AuditRecordEvent> | AuditRecordEvent | null | undefined
  source?: string | null | undefined
  parentId?: string | null | undefined
  dateRangeStart?: DateInput | null | undefined
  dateRangeEnd?: DateInput | null | undefined
  first?: number | null | undefined
  after?: string | null | undefined
}>

export type AuditGetPageQuery = {
  auditGet: {
    edges: Array<{
      node: {
        id: number
        event: AuditRecordEvent
        source: string
        parentId: string
        entityId: string
        field: string
        before: string
        after: string
        user: { id: string; name: string } | null
        time: {
          milliseconds: string
          plaindate: string
          plaintime: string
          timezone: string
        }
      }
    }>
    pageInfo: { hasNextPage: boolean; endCursor: string | null }
  }
}

export type AircraftCreateMutationVariables = Exact<{
  input: MutationAircraftCreateInput
}>

export type AircraftCreateMutation = { aircraftCreate: { id: string } }

export type AircraftUpdateMutationVariables = Exact<{
  input: MutationAircraftUpdateInput
}>

export type AircraftUpdateMutation = {
  aircraftUpdate: {
    id: string
    tail: string
    manufacturer: string
    model: string
    serial: string
    yom: string
    yor: string
    category: string
    pax: string
  }
}

export type FleetListQueryVariables = Exact<{
  input: QueryAircraftByOrganizationInput
}>

export type FleetListQuery = {
  aircraftByOrganization: Array<{
    id: string
    source: AircraftSource
    tail: string
    manufacturer: string
    model: string
    yom: string
    category: string
    serial: string
    images: Array<string>
    owners: Array<{ id: string; name: string }> | null
    keyAccountManagers: Array<{ id: string; name: string; image: string | null }>
  }>
}

export type FlightsGetPaginatedQueryVariables = Exact<{
  first?: number | null | undefined
  after?: string | null | undefined
  isCnl: boolean
  term?: string | null | undefined
  status?: Array<FlightType> | FlightType | null | undefined
  aircraftIds?: Array<string> | string | null | undefined
  departureIds?: Array<string> | string | null | undefined
  arrivalIds?: Array<string> | string | null | undefined
  dateRangeStart: DateInput
  dateRangeEnd: DateInput
}>

export type FlightsGetPaginatedQuery = {
  flightsGetPaginated: {
    edges: Array<{
      node: {
        id: string
        aircraftId: string
        flightType: FlightType | null
        flightStatus: FlightStatus | null
        flightNumber: string
        sequenceNumber: number
        flightMinutes: number
        flightMinutesString: string
        flightPax: string
        code: string
        aircraft: { id: string; tail: string } | null
        departureDate: {
          plaindate: string
          plaintime: string
          timezone: string
          RFC3339: string
        } | null
        departureAirport: { id: string; code: string; city: string }
        arrivalDate: {
          plaindate: string
          plaintime: string
          timezone: string
          RFC3339: string
        } | null
        arrivalAirport: { id: string; code: string; city: string }
        flightDistance: { value: string; units: DistanceUnit }
      }
    }>
    pageInfo: { hasNextPage: boolean; endCursor: string | null }
  }
}

export type FlightsTableGetPaginatedQueryVariables = Exact<{
  first?: number | null | undefined
  after?: string | null | undefined
  isCnl: boolean
  term?: string | null | undefined
  status?: Array<FlightType> | FlightType | null | undefined
  aircraftIds?: Array<string> | string | null | undefined
  departureIds?: Array<string> | string | null | undefined
  arrivalIds?: Array<string> | string | null | undefined
  dateRangeStart: DateInput
  dateRangeEnd: DateInput
}>

export type FlightsTableGetPaginatedQuery = {
  flightsGetPaginated: {
    edges: Array<{
      node: {
        id: string
        source: DataSource
        flightType: FlightType | null
        flightMinutes: number
        code: string
        aircraft: { id: string; tail: string } | null
        departureDate: { plaindate: string } | null
        departureAirport: { id: string; code: string; city: string }
        arrivalAirport: { id: string; code: string; city: string }
        flightDistance: { value: string; units: DistanceUnit }
        fuelTransformed: {
          fuelBeforeUplift: number | null
          usedFuel: number
          remainingFuel: number | null
          fuelUnit: FuelUnit
        } | null
        flightCrewList: Array<{
          id: string
          role: CrewRole | null
          firstName: string
          lastName: string
        }>
        flightPaxList: Array<{ id: string; firstName: string; lastName: string }>
      }
    }>
    pageInfo: { hasNextPage: boolean; endCursor: string | null }
  }
}

export type FlightsGetSummaryQueryVariables = Exact<{
  input: QueryFlightsGetSummaryInput
}>

export type FlightsGetSummaryQuery = {
  flightsGetSummary: {
    count: number
    totalMinutes: number
    totalMinutesString: string
    usedFuel: number
    fuelUnit: FuelUnit
  }
}

export type FlightsOverrideMutationVariables = Exact<{
  input: MutationFlightsOverrideInput
}>

export type FlightsOverrideMutation = {
  flightsOverride: { id: string; flightType: FlightType | null }
}

export type FlightsGetAnalyticsQueryVariables = Exact<{
  input: QueryFlightsGetAnalyticsInput
}>

export type FlightsGetAnalyticsQuery = {
  flightsGetAnalytics: {
    totalFlights: number
    totalMinutes: number
    totalMinutesString: string
    totalDistance: number
    averageMinutes: number
    averageMinutesString: string
    prevTotalFlights: number
    prevTotalMinutes: number
    prevTotalDistance: number
    prevAverageMinutes: number
    monthly: Array<{ month: string; flights: number; totalMinutes: number }>
    topDestinations: Array<{ code: string; flights: number }>
    topRoutes: Array<{
      depCode: string
      arrCode: string
      flights: number
      totalDistance: number
    }>
    flightTimeDistribution: Array<{ bucket: string; flights: number }>
  }
}

export type InvoiceUploadApproveMutationVariables = Exact<{
  input: MutationInvoiceUploadApproveInput
}>

export type InvoiceUploadApproveMutation = {
  invoiceUploadApprove: {
    id: string
    status: InvoiceUploadStatus
    approvedAt: string | null
  }
}

export type InvoiceUploadListQueryVariables = Exact<{
  input: QueryInvoiceUploadListInput
}>

export type InvoiceUploadListQuery = {
  invoiceUploadList: Array<{
    id: string
    fileName: string
    mimeType: string
    blobName: string
    size: number
    status: InvoiceUploadStatus
    documentKind: InvoiceDocumentKind | null
    purNumber: string | null
    invoiceId: string | null
    postError: string | null
    vendor: string | null
    serviceMonth: string | null
    serviceMonthDisplay: string | null
    late: boolean | null
    classificationNote: string | null
    createdDate: { milliseconds: string; displaydate: string; displaytime: string }
  }>
}

export type InvoiceUploadAddMutationVariables = Exact<{
  input: MutationInvoiceUploadAddInput
}>

export type InvoiceUploadAddMutation = { invoiceUploadAdd: { id: string } }

export type InvoiceLateListQueryVariables = Exact<{
  input: QueryInvoiceLateListInput
}>

export type InvoiceLateListQuery = {
  invoiceLateList: Array<{
    id: string
    number: string
    vendor: string
    aircraftId: string | null
    currency: Currency
    total: string
    daysLate: number
    serviceDate: { plaindate: string; displaydate: string }
    invoiceDate: { plaindate: string; displaydate: string }
  }>
}

export type InvoiceCategoriesQueryVariables = Exact<{
  input: QueryInvoiceCategoriesGetInput
}>

export type InvoiceCategoriesQuery = {
  invoiceCategoriesGet: Array<{ id: string; code: string; description: string }>
}

export type InvoiceLegCodesQueryVariables = Exact<{
  input: QueryInvoiceLegCodesInput
}>

export type InvoiceLegCodesQuery = {
  invoiceLegCodes: Array<{
    code: string
    tails: Array<string>
    arrival: { displaydate: string }
  }>
}

export type InvoiceUpdateMutationVariables = Exact<{
  input: MutationInvoiceUpdateInput
}>

export type InvoiceUpdateMutation = { invoiceUpdate: { id: string } }

export type InvoiceMonthInboxQueryVariables = Exact<{
  input: QueryInvoiceMonthInboxInput
}>

export type InvoiceMonthInboxQuery = {
  invoiceMonthInbox: Array<{
    categoryId: string | null
    code: string | null
    description: string | null
    invoiceCount: number
    lateCount: number
    totals: Array<{ currency: Currency; amount: string }>
    invoices: Array<{
      id: string
      aircraftId: string | null
      number: string
      vendor: string
      type: InvoiceType
      needsReview: boolean
      source: InvoiceDataSource
      currency: Currency
      subtotal: string
      vat: string
      total: string
      airportCode: string | null
      legCode: string | null
      description: string
      notes: string
      serviceDate: { displaydate: string }
      invoiceDate: { displaydate: string }
      dueDate: { displaydate: string } | null
      paymentDate: { displaydate: string } | null
      files: Array<{
        id: string
        fileName: string
        mimeType: string
        blobName: string
        documentKind: InvoiceDocumentKind | null
      }>
    }>
  }>
}

export type InvoiceMonthSummariesQueryVariables = Exact<{
  input: QueryInvoiceMonthSummariesInput
}>

export type InvoiceMonthSummariesQuery = {
  invoiceMonthSummaries: Array<{
    month: number
    invoiceCount: number
    lateCount: number
    needsReviewCount: number
    totals: Array<{ currency: Currency; amount: string }>
  }>
}

export type LeonIntegrationConnectMutationVariables = Exact<{
  input: MutationLeonIntegrationConnectInput
}>

export type LeonIntegrationConnectMutation = {
  leonIntegrationConnect: {
    refreshToken: string
    operatorId: string
    createdAt: string
    lastUsedAt: string
  }
}

export type LeonIntegrationRemoveMutationVariables = Exact<{
  input: MutationLeonIntegrationRemoveInput
}>

export type LeonIntegrationRemoveMutation = { leonIntegrationRemove: boolean }

export type LeonIntegrationInitialSyncMutationVariables = Exact<{
  input: MutationLeonIntegrationInitialSyncInput
}>

export type LeonIntegrationInitialSyncMutation = { leonIntegrationInitialSync: boolean }

export type LeonIntegrationInitialSyncAbortMutationVariables = Exact<{
  [key: string]: never
}>

export type LeonIntegrationInitialSyncAbortMutation = {
  leonIntegrationInitialSyncAbort: boolean
}

export type LeonIntegrationIncrementalSyncStartMutationVariables = Exact<{
  [key: string]: never
}>

export type LeonIntegrationIncrementalSyncStartMutation = {
  leonIntegrationIncrementalSyncStart: boolean
}

export type LeonIntegrationGetTokenQueryVariables = Exact<{
  input: QueryLeonIntegrationGetTokenInput
}>

export type LeonIntegrationGetTokenQuery = {
  leonIntegrationGetToken: {
    refreshToken: string
    operatorId: string
    createdAt: string
    lastUsedAt: string
    lastSyncDate: { RFC3339: string } | null
  }
}

export type LeonIntegrationGetEventsQueryVariables = Exact<{
  input: QueryLeonIntegrationGetEventsInput
}>

export type LeonIntegrationGetEventsQuery = {
  leonIntegrationGetEvents: Array<{
    id: number
    event: AuditRecordEvent
    after: string
    user: { name: string } | null
    time: { RFC3339: string }
  }>
}

export type LeonIntegrationInitialSyncLockQueryVariables = Exact<{ [key: string]: never }>

export type LeonIntegrationInitialSyncLockQuery = {
  leonIntegrationInitialSyncLock: boolean
}

export type PresetsGetMutationVariables = Exact<{
  input: MutationPresetsGetInput
}>

export type PresetsGetMutation = {
  presetsGet: {
    id: string
    organizationId: string
    userId: string | null
    initial: InitialSystem
    distance: DistanceUnit
    fuel: FuelUnit
    weight: WeightUnit
    temperature: TemperatureUnit
    pressure: PressureUnit
    decimalSeparator: DecimapSeparatorFormat
    thousandsSeparator: ThousandsSeparatorFormat
    dateFormat: DateOptionFormat
    timeFormat: TimeOptionFormat
  }
}

export type PresetsUpdateMutationVariables = Exact<{
  input: MutationPresetsUpdateInput
}>

export type PresetsUpdateMutation = {
  presetsUpdate: {
    id: string
    organizationId: string
    userId: string | null
    initial: InitialSystem
    distance: DistanceUnit
    fuel: FuelUnit
    weight: WeightUnit
    temperature: TemperatureUnit
    pressure: PressureUnit
    decimalSeparator: DecimapSeparatorFormat
    thousandsSeparator: ThousandsSeparatorFormat
    dateFormat: DateOptionFormat
    timeFormat: TimeOptionFormat
  }
}

export type UserImageUploadMutationVariables = Exact<{
  input: MutationPublicFileUploadInput
}>

export type UserImageUploadMutation = { publicFileUpload: string }

export type UserUpdateImageMutationVariables = Exact<{
  input: MutationUserUpdateImageInput
}>

export type UserUpdateImageMutation = {
  userUpdateImage: { id: string; image: string | null }
}

export type OrganizationLogoUploadMutationVariables = Exact<{
  input: MutationPublicFileUploadInput
}>

export type OrganizationLogoUploadMutation = { publicFileUpload: string }

export type OrganizationUpdateMutationVariables = Exact<{
  input: MutationOrganizationUpdateInput
}>

export type OrganizationUpdateMutation = {
  organizationUpdate: { id: string; name: string; slug: string; logo: string | null }
}

export type AircraftNameQueryVariables = Exact<{
  input: QueryAircraftByIdInput
}>

export type AircraftNameQuery = {
  aircraftById: { id: string; tail: string; manufacturer: string; model: string }
}

export type FetchUserInfo_UserFragment = {
  id: string
  email: string
  name: string
  emailVerified: boolean
  phone: string | null
  role: Array<string>
  image: string | null
  createdAt: string
  updatedAt: string
} & { " $fragmentName"?: "FetchUserInfo_UserFragment" }

export type FetchUserInfo_OrganizationFragment = {
  id: string
  name: string
  slug: string
  logo: string | null
  metadata: string | null
} & { " $fragmentName"?: "FetchUserInfo_OrganizationFragment" }

export type FetchUserInfo_MeLoggedInFragment = {
  isLoggedIn: true
  activeInvite: true
  user: { " $fragmentRefs"?: { FetchUserInfo_UserFragment: FetchUserInfo_UserFragment } }
  organization: {
    " $fragmentRefs"?: {
      FetchUserInfo_OrganizationFragment: FetchUserInfo_OrganizationFragment
    }
  }
} & { " $fragmentName"?: "FetchUserInfo_MeLoggedInFragment" }

export type FetchUserInfo_MeQueryVariables = Exact<{ [key: string]: never }>

export type FetchUserInfo_MeQuery = {
  me:
    | ({ __typename: "MeLoggedIn" } & {
        " $fragmentRefs"?: {
          FetchUserInfo_MeLoggedInFragment: FetchUserInfo_MeLoggedInFragment
        }
      })
    | { __typename: "MeNotLoggedIn" }
}

export type OrganizationEventsSubscriptionVariables = Exact<{ [key: string]: never }>

export type OrganizationEventsSubscription = {
  organizationEvents: { event: SubscriptionEventType; payload: string }
}

export type HealthcheckQueryVariables = Exact<{ [key: string]: never }>

export type HealthcheckQuery = { healthcheck: boolean }

export const FetchUserInfo_UserFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "fetchUserInfo_User" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "emailVerified" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "image" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchUserInfo_UserFragment, unknown>
export const FetchUserInfo_OrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "fetchUserInfo_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "logo" } },
          { kind: "Field", name: { kind: "Name", value: "metadata" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchUserInfo_OrganizationFragment, unknown>
export const FetchUserInfo_MeLoggedInFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "fetchUserInfo_MeLoggedIn" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeLoggedIn" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "isLoggedIn" } },
          { kind: "Field", name: { kind: "Name", value: "activeInvite" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "fetchUserInfo_User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "fetchUserInfo_Organization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "fetchUserInfo_User" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "emailVerified" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "image" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "fetchUserInfo_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "logo" } },
          { kind: "Field", name: { kind: "Name", value: "metadata" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchUserInfo_MeLoggedInFragment, unknown>
export const AircraftCategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AircraftCategories" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "aircraftCategories" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AircraftCategoriesQuery, AircraftCategoriesQueryVariables>
export const AirportGetByTermDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AirportGetByTerm" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAirportGetByTermInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "airportGetByTerm" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "tz" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AirportGetByTermQuery, AirportGetByTermQueryVariables>
export const CrewByOrganizationSelectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CrewByOrganizationSelect" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryCrewByOrganizationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "crewByOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CrewByOrganizationSelectQuery,
  CrewByOrganizationSelectQueryVariables
>
export const OperatorByOrganizationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OperatorByOrganization" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryOperatorByOrganizationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "operatorByOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OperatorByOrganizationQuery,
  OperatorByOrganizationQueryVariables
>
export const OwnerByOrganizationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OwnerByOrganization" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryOwnerByOrganizationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerByOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OwnerByOrganizationQuery, OwnerByOrganizationQueryVariables>
export const OrganizationUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrganizationUsers" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "image" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationUsersQuery, OrganizationUsersQueryVariables>
export const GlobalSearchDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GlobalSearch" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "term" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "search" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "term" },
                value: { kind: "Variable", name: { kind: "Name", value: "term" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aircraft" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "source" } },
                      { kind: "Field", name: { kind: "Name", value: "tail" } },
                      { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
                      { kind: "Field", name: { kind: "Name", value: "model" } },
                      { kind: "Field", name: { kind: "Name", value: "serial" } },
                      { kind: "Field", name: { kind: "Name", value: "images" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GlobalSearchQuery, GlobalSearchQueryVariables>
export const LlmConfigurationsPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LlmConfigurationsPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryLlmConfigurationsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "llmConfigurations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "provider" } },
                { kind: "Field", name: { kind: "Name", value: "endpoint" } },
                { kind: "Field", name: { kind: "Name", value: "model" } },
                { kind: "Field", name: { kind: "Name", value: "apiKeyLast4" } },
                { kind: "Field", name: { kind: "Name", value: "isDefault" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LlmConfigurationsPageQuery,
  LlmConfigurationsPageQueryVariables
>
export const LlmConfigurationCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LlmConfigurationCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationLlmConfigurationCreateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "llmConfigurationCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LlmConfigurationCreateMutation,
  LlmConfigurationCreateMutationVariables
>
export const LlmConfigurationUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LlmConfigurationUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationLlmConfigurationUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "llmConfigurationUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LlmConfigurationUpdateMutation,
  LlmConfigurationUpdateMutationVariables
>
export const LlmConfigurationSetDefaultDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LlmConfigurationSetDefault" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationLlmConfigurationSetDefaultInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "llmConfigurationSetDefault" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LlmConfigurationSetDefaultMutation,
  LlmConfigurationSetDefaultMutationVariables
>
export const LlmConfigurationDeleteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LlmConfigurationDelete" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationLlmConfigurationDeleteInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "llmConfigurationDelete" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LlmConfigurationDeleteMutation,
  LlmConfigurationDeleteMutationVariables
>
export const AircraftSettingsListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AircraftSettingsList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftByOrganizationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftByOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "tail" } },
                { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
                { kind: "Field", name: { kind: "Name", value: "model" } },
                { kind: "Field", name: { kind: "Name", value: "serial" } },
                { kind: "Field", name: { kind: "Name", value: "isHidden" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftSettingsListQuery,
  AircraftSettingsListQueryVariables
>
export const AircraftSwitchHiddenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftSwitchHidden" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftSwitchHiddenInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftSwitchHidden" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftSwitchHiddenMutation,
  AircraftSwitchHiddenMutationVariables
>
export const CrewByOrganizationPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CrewByOrganizationPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryCrewByOrganizationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "crewByOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "positions" } },
                { kind: "Field", name: { kind: "Name", value: "info" } },
                { kind: "Field", name: { kind: "Name", value: "primaryAircraftId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "primaryAircraft" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "source" } },
                      { kind: "Field", name: { kind: "Name", value: "tail" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CrewByOrganizationPageQuery,
  CrewByOrganizationPageQueryVariables
>
export const CrewCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CrewCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationCrewCreateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "crewCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CrewCreateMutation, CrewCreateMutationVariables>
export const CrewUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CrewUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationCrewUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "crewUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CrewUpdateMutation, CrewUpdateMutationVariables>
export const OperatorsByOrganizationPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OperatorsByOrganizationPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryOperatorByOrganizationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "operatorByOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OperatorsByOrganizationPageQuery,
  OperatorsByOrganizationPageQueryVariables
>
export const OperatorCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OperatorCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationOperatorCreateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "operatorCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OperatorCreateMutation, OperatorCreateMutationVariables>
export const OperatorUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OperatorUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationOperatorUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "operatorUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OperatorUpdateMutation, OperatorUpdateMutationVariables>
export const OwnerUpdateOnBoardRulesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OwnerUpdateOnBoardRules" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationOwnerUpdateOnBoardRulesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerUpdateOnBoardRules" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OwnerUpdateOnBoardRulesMutation,
  OwnerUpdateOnBoardRulesMutationVariables
>
export const OwnerUpdateServiceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OwnerUpdateService" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationOwnerUpdateServiceInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerUpdateService" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OwnerUpdateServiceMutation,
  OwnerUpdateServiceMutationVariables
>
export const OwnerUpdateNotesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OwnerUpdateNotes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationOwnerUpdateNotesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerUpdateNotes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OwnerUpdateNotesMutation, OwnerUpdateNotesMutationVariables>
export const OwnersByOrganizationPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OwnersByOrganizationPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryOwnerByOrganizationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerByOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "onBoardRuleForPets" } },
                { kind: "Field", name: { kind: "Name", value: "onBoardRuleForAlcohol" } },
                { kind: "Field", name: { kind: "Name", value: "onBoardRuleForSmoking" } },
                { kind: "Field", name: { kind: "Name", value: "onBoardRuleForWeapons" } },
                { kind: "Field", name: { kind: "Name", value: "onBoardCateringPolicy" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "onBoardPassengerPolicy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "servicePreferredCabinTemperature" },
                },
                { kind: "Field", name: { kind: "Name", value: "serviceFlowers" } },
                { kind: "Field", name: { kind: "Name", value: "serviceBedding" } },
                { kind: "Field", name: { kind: "Name", value: "serviceEntertainment" } },
                { kind: "Field", name: { kind: "Name", value: "serviceFragrance" } },
                { kind: "Field", name: { kind: "Name", value: "serviceCatering" } },
                { kind: "Field", name: { kind: "Name", value: "serviceLighting" } },
                { kind: "Field", name: { kind: "Name", value: "notes" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OwnersByOrganizationPageQuery,
  OwnersByOrganizationPageQueryVariables
>
export const OwnerCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OwnerCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationOwnerCreateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OwnerCreateMutation, OwnerCreateMutationVariables>
export const OwnerUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OwnerUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationOwnerUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OwnerUpdateMutation, OwnerUpdateMutationVariables>
export const AgentFileUploadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AgentFileUpload" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAgentFileUploadInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "agentFileUpload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "mimeType" } },
                { kind: "Field", name: { kind: "Name", value: "size" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgentFileUploadMutation, AgentFileUploadMutationVariables>
export const AgentFileDeleteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AgentFileDelete" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAgentFileDeleteInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "agentFileDelete" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgentFileDeleteMutation, AgentFileDeleteMutationVariables>
export const OrganizationMembersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrganizationMembers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryOrganizationUsersInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "image" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationMembersQuery, OrganizationMembersQueryVariables>
export const OrganizationInviteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrganizationInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationOrganizationInviteInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrganizationInviteMutation,
  OrganizationInviteMutationVariables
>
export const DashboardFleetCountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DashboardFleetCount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftByOrganizationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftByOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DashboardFleetCountQuery, DashboardFleetCountQueryVariables>
export const AircraftByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AircraftById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftByIdInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "tail" } },
                { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
                { kind: "Field", name: { kind: "Name", value: "model" } },
                { kind: "Field", name: { kind: "Name", value: "serial" } },
                { kind: "Field", name: { kind: "Name", value: "yom" } },
                { kind: "Field", name: { kind: "Name", value: "yor" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "pax" } },
                { kind: "Field", name: { kind: "Name", value: "images" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keyAccountManagers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "image" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "operators" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "source" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "owners" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AircraftByIdQuery, AircraftByIdQueryVariables>
export const PublicFileUploadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PublicFileUpload" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationPublicFileUploadInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publicFileUpload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublicFileUploadMutation, PublicFileUploadMutationVariables>
export const AircraftUpdateImagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftUpdateImages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftUpdateImagesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftUpdateImages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "images" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftUpdateImagesMutation,
  AircraftUpdateImagesMutationVariables
>
export const AircraftSetKeyAccountManagersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftSetKeyAccountManagers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftSetKeyAccountManagersInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftSetKeyAccountManagers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftSetKeyAccountManagersMutation,
  AircraftSetKeyAccountManagersMutationVariables
>
export const AircraftAddOperatorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftAddOperator" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftAddOperatorInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftAddOperator" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftAddOperatorMutation,
  AircraftAddOperatorMutationVariables
>
export const AircraftAddOwnerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftAddOwner" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftAddOwnerInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftAddOwner" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AircraftAddOwnerMutation, AircraftAddOwnerMutationVariables>
export const AircraftDocumentAddDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftDocumentAdd" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftDocumentAddInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftDocumentAdd" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftDocumentAddMutation,
  AircraftDocumentAddMutationVariables
>
export const DocumentCategoriesGetDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DocumentCategoriesGet" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryDocumentCategoriesGetInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "documentCategoriesGet" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "parentId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "critical" } },
                { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DocumentCategoriesGetQuery,
  DocumentCategoriesGetQueryVariables
>
export const AircraftDocumentListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AircraftDocumentList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftDocumentListInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftDocumentList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "categoryId" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "originalName" } },
                { kind: "Field", name: { kind: "Name", value: "mimeType" } },
                { kind: "Field", name: { kind: "Name", value: "size" } },
                { kind: "Field", name: { kind: "Name", value: "effectiveDate" } },
                { kind: "Field", name: { kind: "Name", value: "expiryDate" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftDocumentListQuery,
  AircraftDocumentListQueryVariables
>
export const AircraftEquipmentAddDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftEquipmentAdd" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftEquipmentAddInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftEquipmentAdd" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
                { kind: "Field", name: { kind: "Name", value: "model" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "installedAt" } },
                { kind: "Field", name: { kind: "Name", value: "isVisible" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftEquipmentAddMutation,
  AircraftEquipmentAddMutationVariables
>
export const AircraftSpecificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AircraftSpecification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftSpecificationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftSpecification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "aircraftId" } },
                { kind: "Field", name: { kind: "Name", value: "useDefaults" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "range" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "speed" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ceiling" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "takeoffDistance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "landingDistance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fuelCapacity" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baggageCapacity" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "hours" } },
                { kind: "Field", name: { kind: "Name", value: "landings" } },
                { kind: "Field", name: { kind: "Name", value: "cabinZones" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftSpecificationQuery,
  AircraftSpecificationQueryVariables
>
export const AircraftEquipmentListCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AircraftEquipmentListCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftEquipmentListInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftEquipmentList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "isVisible" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftEquipmentListCardQuery,
  AircraftEquipmentListCardQueryVariables
>
export const CrewCreateModalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CrewCreateModal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationCrewCreateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "crewCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CrewCreateModalMutation, CrewCreateModalMutationVariables>
export const AircraftAddCrewModalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftAddCrewModal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftAddCrewInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftAddCrew" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftAddCrewModalMutation,
  AircraftAddCrewModalMutationVariables
>
export const AircraftRemoveCrewModalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftRemoveCrewModal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftRemoveCrewInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftRemoveCrew" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftRemoveCrewModalMutation,
  AircraftRemoveCrewModalMutationVariables
>
export const AircraftSpecificationUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftSpecificationUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftSpecificationUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftSpecificationUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "aircraftId" } },
                { kind: "Field", name: { kind: "Name", value: "useDefaults" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "range" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "speed" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ceiling" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "takeoffDistance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "landingDistance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fuelCapacity" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "baggageCapacity" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "units" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "hours" } },
                { kind: "Field", name: { kind: "Name", value: "landings" } },
                { kind: "Field", name: { kind: "Name", value: "cabinZones" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftSpecificationUpdateMutation,
  AircraftSpecificationUpdateMutationVariables
>
export const AircraftEquipmentListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AircraftEquipmentList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftEquipmentListInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftEquipmentList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "aircraftId" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
                { kind: "Field", name: { kind: "Name", value: "model" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "installedAt" } },
                { kind: "Field", name: { kind: "Name", value: "isVisible" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftEquipmentListQuery,
  AircraftEquipmentListQueryVariables
>
export const AircraftEquipmentNotesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AircraftEquipmentNotes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftByIdInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "equipmentNotes" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftEquipmentNotesQuery,
  AircraftEquipmentNotesQueryVariables
>
export const AircraftEquipmentUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftEquipmentUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftEquipmentUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftEquipmentUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
                { kind: "Field", name: { kind: "Name", value: "model" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "installedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftEquipmentUpdateMutation,
  AircraftEquipmentUpdateMutationVariables
>
export const AircraftEquipmentRemoveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftEquipmentRemove" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftEquipmentRemoveInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftEquipmentRemove" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftEquipmentRemoveMutation,
  AircraftEquipmentRemoveMutationVariables
>
export const AircraftUpdateEquipmentNotesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftUpdateEquipmentNotes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "equipmentNotes" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftUpdateEquipmentNotesMutation,
  AircraftUpdateEquipmentNotesMutationVariables
>
export const AircraftAddOwnerOwnershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftAddOwnerOwnership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftAddOwnerInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftAddOwner" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftAddOwnerOwnershipMutation,
  AircraftAddOwnerOwnershipMutationVariables
>
export const AircraftAddOperatorOwnershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftAddOperatorOwnership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftAddOperatorInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftAddOperator" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftAddOperatorOwnershipMutation,
  AircraftAddOperatorOwnershipMutationVariables
>
export const AircraftSetKamsOwnershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftSetKamsOwnership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftSetKeyAccountManagersInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftSetKeyAccountManagers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftSetKamsOwnershipMutation,
  AircraftSetKamsOwnershipMutationVariables
>
export const AircraftUpdateDatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftUpdateDates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "certificateExpirationDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "registrationExpirationDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "insuranceRenewalDate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftUpdateDatesMutation,
  AircraftUpdateDatesMutationVariables
>
export const PowerplantSystemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PowerplantSystems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ppInput" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftSystemByTypeInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "apuInput" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftSystemByTypeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "powerplant" },
            name: { kind: "Name", value: "aircraftSystemByType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "ppInput" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "provider" } },
                { kind: "Field", name: { kind: "Name", value: "registryCountry" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "contractReference" } },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "apu" },
            name: { kind: "Name", value: "aircraftSystemByType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "apuInput" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "provider" } },
                { kind: "Field", name: { kind: "Name", value: "registryCountry" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "contractReference" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PowerplantSystemsQuery, PowerplantSystemsQueryVariables>
export const AircraftSystemUpdatePpDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftSystemUpdatePP" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftSystemUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftSystemUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "provider" } },
                { kind: "Field", name: { kind: "Name", value: "registryCountry" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "contractReference" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftSystemUpdatePpMutation,
  AircraftSystemUpdatePpMutationVariables
>
export const AircraftByIdGeneralInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AircraftByIdGeneralInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftByIdInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "tail" } },
                { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
                { kind: "Field", name: { kind: "Name", value: "model" } },
                { kind: "Field", name: { kind: "Name", value: "serial" } },
                { kind: "Field", name: { kind: "Name", value: "yom" } },
                { kind: "Field", name: { kind: "Name", value: "yor" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "locationId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "source" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "pax" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "crew" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "source" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "lastName" } },
                      { kind: "Field", name: { kind: "Name", value: "role" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftByIdGeneralInfoQuery,
  AircraftByIdGeneralInfoQueryVariables
>
export const AircraftByIdOwnerPreferencesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AircraftByIdOwnerPreferences" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftByIdInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "owners" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "onBoardRuleForPets" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "onBoardRuleForAlcohol" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "onBoardRuleForSmoking" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "onBoardRuleForWeapons" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "onBoardCateringPolicy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "onBoardPassengerPolicy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "servicePreferredCabinTemperature" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "serviceFlowers" } },
                      { kind: "Field", name: { kind: "Name", value: "serviceBedding" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serviceEntertainment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serviceFragrance" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "serviceCatering" } },
                      { kind: "Field", name: { kind: "Name", value: "serviceLighting" } },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftByIdOwnerPreferencesQuery,
  AircraftByIdOwnerPreferencesQueryVariables
>
export const AircraftByIdOwnershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AircraftByIdOwnership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftByIdInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "certificateExpirationDate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "registrationExpirationDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "insuranceRenewalDate" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "updatedByUser" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "image" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "owners" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "operators" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keyAccountManagers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "image" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AircraftByIdOwnershipQuery,
  AircraftByIdOwnershipQueryVariables
>
export const PowerplantCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PowerplantCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ppInput" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftSystemByTypeInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "apuInput" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftSystemByTypeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "powerplant" },
            name: { kind: "Name", value: "aircraftSystemByType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "ppInput" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "provider" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "apu" },
            name: { kind: "Name", value: "aircraftSystemByType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "apuInput" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "provider" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PowerplantCardQuery, PowerplantCardQueryVariables>
export const AuditGetCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AuditGetCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "events" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "AuditRecordEvent" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "source" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "parentId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "auditGet" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "events" },
                value: { kind: "Variable", name: { kind: "Name", value: "events" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "source" },
                value: { kind: "Variable", name: { kind: "Name", value: "source" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "parentId" },
                value: { kind: "Variable", name: { kind: "Name", value: "parentId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "event" } },
                            { kind: "Field", name: { kind: "Name", value: "entityId" } },
                            { kind: "Field", name: { kind: "Name", value: "field" } },
                            { kind: "Field", name: { kind: "Name", value: "before" } },
                            { kind: "Field", name: { kind: "Name", value: "after" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "time" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "milliseconds" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuditGetCardQuery, AuditGetCardQueryVariables>
export const AuditGetPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AuditGetPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "events" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "AuditRecordEvent" },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "source" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "parentId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateRangeStart" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "DateInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateRangeEnd" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "DateInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "auditGet" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "events" },
                value: { kind: "Variable", name: { kind: "Name", value: "events" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "source" },
                value: { kind: "Variable", name: { kind: "Name", value: "source" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "parentId" },
                value: { kind: "Variable", name: { kind: "Name", value: "parentId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateRangeStart" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateRangeStart" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateRangeEnd" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateRangeEnd" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "event" } },
                            { kind: "Field", name: { kind: "Name", value: "source" } },
                            { kind: "Field", name: { kind: "Name", value: "parentId" } },
                            { kind: "Field", name: { kind: "Name", value: "entityId" } },
                            { kind: "Field", name: { kind: "Name", value: "field" } },
                            { kind: "Field", name: { kind: "Name", value: "before" } },
                            { kind: "Field", name: { kind: "Name", value: "after" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "time" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "milliseconds" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "plaindate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "plaintime" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "timezone" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuditGetPageQuery, AuditGetPageQueryVariables>
export const AircraftCreateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftCreate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftCreateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftCreate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AircraftCreateMutation, AircraftCreateMutationVariables>
export const AircraftUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AircraftUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationAircraftUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tail" } },
                { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
                { kind: "Field", name: { kind: "Name", value: "model" } },
                { kind: "Field", name: { kind: "Name", value: "serial" } },
                { kind: "Field", name: { kind: "Name", value: "yom" } },
                { kind: "Field", name: { kind: "Name", value: "yor" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "pax" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AircraftUpdateMutation, AircraftUpdateMutationVariables>
export const FleetListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FleetList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftByOrganizationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftByOrganization" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "tail" } },
                { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
                { kind: "Field", name: { kind: "Name", value: "model" } },
                { kind: "Field", name: { kind: "Name", value: "yom" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "serial" } },
                { kind: "Field", name: { kind: "Name", value: "images" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "owners" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keyAccountManagers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "image" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FleetListQuery, FleetListQueryVariables>
export const FlightsGetPaginatedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FlightsGetPaginated" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "isCnl" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "term" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "FlightType" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "aircraftIds" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "departureIds" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "arrivalIds" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateRangeStart" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DateInput" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateRangeEnd" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "flightsGetPaginated" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isCnl" },
                value: { kind: "Variable", name: { kind: "Name", value: "isCnl" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "term" },
                value: { kind: "Variable", name: { kind: "Name", value: "term" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "Variable", name: { kind: "Name", value: "status" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "aircraftIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "aircraftIds" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "departureIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "departureIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "arrivalIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "arrivalIds" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateRangeStart" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateRangeStart" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateRangeEnd" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateRangeEnd" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "aircraftId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "aircraft" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tail" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "flightType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "flightStatus" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "flightNumber" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sequenceNumber" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "departureDate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "plaindate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "plaintime" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "timezone" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "RFC3339" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "departureAirport" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "city" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "arrivalDate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "plaindate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "plaintime" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "timezone" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "RFC3339" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "arrivalAirport" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "city" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "flightMinutes" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "flightMinutesString" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "flightDistance" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "units" },
                                  },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "flightPax" } },
                            { kind: "Field", name: { kind: "Name", value: "code" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FlightsGetPaginatedQuery, FlightsGetPaginatedQueryVariables>
export const FlightsTableGetPaginatedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FlightsTableGetPaginated" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "isCnl" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "term" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "FlightType" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "aircraftIds" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "departureIds" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "arrivalIds" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateRangeStart" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DateInput" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateRangeEnd" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "DateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "flightsGetPaginated" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isCnl" },
                value: { kind: "Variable", name: { kind: "Name", value: "isCnl" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "term" },
                value: { kind: "Variable", name: { kind: "Name", value: "term" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: { kind: "Variable", name: { kind: "Name", value: "status" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "aircraftIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "aircraftIds" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "departureIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "departureIds" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "arrivalIds" },
                value: { kind: "Variable", name: { kind: "Name", value: "arrivalIds" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateRangeStart" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateRangeStart" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateRangeEnd" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateRangeEnd" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "source" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "aircraft" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tail" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "flightType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "departureDate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "plaindate" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "departureAirport" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "city" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "arrivalAirport" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "city" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "flightMinutes" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "flightDistance" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "units" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fuelTransformed" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "fuelBeforeUplift" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "usedFuel" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "remainingFuel" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "fuelUnit" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "flightCrewList" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "role" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastName" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "flightPaxList" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastName" },
                                  },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "code" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FlightsTableGetPaginatedQuery,
  FlightsTableGetPaginatedQueryVariables
>
export const FlightsGetSummaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FlightsGetSummary" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryFlightsGetSummaryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "flightsGetSummary" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "count" } },
                { kind: "Field", name: { kind: "Name", value: "totalMinutes" } },
                { kind: "Field", name: { kind: "Name", value: "totalMinutesString" } },
                { kind: "Field", name: { kind: "Name", value: "usedFuel" } },
                { kind: "Field", name: { kind: "Name", value: "fuelUnit" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FlightsGetSummaryQuery, FlightsGetSummaryQueryVariables>
export const FlightsOverrideDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "FlightsOverride" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationFlightsOverrideInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "flightsOverride" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "flightType" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FlightsOverrideMutation, FlightsOverrideMutationVariables>
export const FlightsGetAnalyticsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FlightsGetAnalytics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryFlightsGetAnalyticsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "flightsGetAnalytics" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalFlights" } },
                { kind: "Field", name: { kind: "Name", value: "totalMinutes" } },
                { kind: "Field", name: { kind: "Name", value: "totalMinutesString" } },
                { kind: "Field", name: { kind: "Name", value: "totalDistance" } },
                { kind: "Field", name: { kind: "Name", value: "averageMinutes" } },
                { kind: "Field", name: { kind: "Name", value: "averageMinutesString" } },
                { kind: "Field", name: { kind: "Name", value: "prevTotalFlights" } },
                { kind: "Field", name: { kind: "Name", value: "prevTotalMinutes" } },
                { kind: "Field", name: { kind: "Name", value: "prevTotalDistance" } },
                { kind: "Field", name: { kind: "Name", value: "prevAverageMinutes" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "monthly" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "month" } },
                      { kind: "Field", name: { kind: "Name", value: "flights" } },
                      { kind: "Field", name: { kind: "Name", value: "totalMinutes" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "topDestinations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      { kind: "Field", name: { kind: "Name", value: "flights" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "topRoutes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "depCode" } },
                      { kind: "Field", name: { kind: "Name", value: "arrCode" } },
                      { kind: "Field", name: { kind: "Name", value: "flights" } },
                      { kind: "Field", name: { kind: "Name", value: "totalDistance" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flightTimeDistribution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "bucket" } },
                      { kind: "Field", name: { kind: "Name", value: "flights" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FlightsGetAnalyticsQuery, FlightsGetAnalyticsQueryVariables>
export const InvoiceUploadApproveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InvoiceUploadApprove" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationInvoiceUploadApproveInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "invoiceUploadApprove" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "approvedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InvoiceUploadApproveMutation,
  InvoiceUploadApproveMutationVariables
>
export const InvoiceUploadListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InvoiceUploadList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryInvoiceUploadListInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "invoiceUploadList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "fileName" } },
                { kind: "Field", name: { kind: "Name", value: "mimeType" } },
                { kind: "Field", name: { kind: "Name", value: "blobName" } },
                { kind: "Field", name: { kind: "Name", value: "size" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "documentKind" } },
                { kind: "Field", name: { kind: "Name", value: "purNumber" } },
                { kind: "Field", name: { kind: "Name", value: "invoiceId" } },
                { kind: "Field", name: { kind: "Name", value: "postError" } },
                { kind: "Field", name: { kind: "Name", value: "vendor" } },
                { kind: "Field", name: { kind: "Name", value: "serviceMonth" } },
                { kind: "Field", name: { kind: "Name", value: "serviceMonthDisplay" } },
                { kind: "Field", name: { kind: "Name", value: "late" } },
                { kind: "Field", name: { kind: "Name", value: "classificationNote" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdDate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "milliseconds" } },
                      { kind: "Field", name: { kind: "Name", value: "displaydate" } },
                      { kind: "Field", name: { kind: "Name", value: "displaytime" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InvoiceUploadListQuery, InvoiceUploadListQueryVariables>
export const InvoiceUploadAddDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InvoiceUploadAdd" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationInvoiceUploadAddInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "invoiceUploadAdd" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InvoiceUploadAddMutation, InvoiceUploadAddMutationVariables>
export const InvoiceLateListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InvoiceLateList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryInvoiceLateListInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "invoiceLateList" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "number" } },
                { kind: "Field", name: { kind: "Name", value: "vendor" } },
                { kind: "Field", name: { kind: "Name", value: "aircraftId" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "total" } },
                { kind: "Field", name: { kind: "Name", value: "daysLate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "serviceDate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "plaindate" } },
                      { kind: "Field", name: { kind: "Name", value: "displaydate" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invoiceDate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "plaindate" } },
                      { kind: "Field", name: { kind: "Name", value: "displaydate" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InvoiceLateListQuery, InvoiceLateListQueryVariables>
export const InvoiceCategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InvoiceCategories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryInvoiceCategoriesGetInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "invoiceCategoriesGet" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InvoiceCategoriesQuery, InvoiceCategoriesQueryVariables>
export const InvoiceLegCodesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InvoiceLegCodes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryInvoiceLegCodesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "invoiceLegCodes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "tails" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "arrival" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "displaydate" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InvoiceLegCodesQuery, InvoiceLegCodesQueryVariables>
export const InvoiceUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InvoiceUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationInvoiceUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "invoiceUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InvoiceUpdateMutation, InvoiceUpdateMutationVariables>
export const InvoiceMonthInboxDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InvoiceMonthInbox" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryInvoiceMonthInboxInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "invoiceMonthInbox" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "categoryId" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "invoiceCount" } },
                { kind: "Field", name: { kind: "Name", value: "lateCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totals" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "amount" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invoices" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "aircraftId" } },
                      { kind: "Field", name: { kind: "Name", value: "number" } },
                      { kind: "Field", name: { kind: "Name", value: "vendor" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "needsReview" } },
                      { kind: "Field", name: { kind: "Name", value: "source" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "subtotal" } },
                      { kind: "Field", name: { kind: "Name", value: "vat" } },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                      { kind: "Field", name: { kind: "Name", value: "airportCode" } },
                      { kind: "Field", name: { kind: "Name", value: "legCode" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serviceDate" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displaydate" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "invoiceDate" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displaydate" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dueDate" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displaydate" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "paymentDate" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displaydate" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "files" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "fileName" } },
                            { kind: "Field", name: { kind: "Name", value: "mimeType" } },
                            { kind: "Field", name: { kind: "Name", value: "blobName" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "documentKind" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InvoiceMonthInboxQuery, InvoiceMonthInboxQueryVariables>
export const InvoiceMonthSummariesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InvoiceMonthSummaries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryInvoiceMonthSummariesInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "invoiceMonthSummaries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "month" } },
                { kind: "Field", name: { kind: "Name", value: "invoiceCount" } },
                { kind: "Field", name: { kind: "Name", value: "lateCount" } },
                { kind: "Field", name: { kind: "Name", value: "needsReviewCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totals" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "amount" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InvoiceMonthSummariesQuery,
  InvoiceMonthSummariesQueryVariables
>
export const LeonIntegrationConnectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LeonIntegrationConnect" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationLeonIntegrationConnectInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leonIntegrationConnect" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "refreshToken" } },
                { kind: "Field", name: { kind: "Name", value: "operatorId" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "lastUsedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeonIntegrationConnectMutation,
  LeonIntegrationConnectMutationVariables
>
export const LeonIntegrationRemoveDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LeonIntegrationRemove" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationLeonIntegrationRemoveInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leonIntegrationRemove" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeonIntegrationRemoveMutation,
  LeonIntegrationRemoveMutationVariables
>
export const LeonIntegrationInitialSyncDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LeonIntegrationInitialSync" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationLeonIntegrationInitialSyncInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leonIntegrationInitialSync" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeonIntegrationInitialSyncMutation,
  LeonIntegrationInitialSyncMutationVariables
>
export const LeonIntegrationInitialSyncAbortDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LeonIntegrationInitialSyncAbort" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leonIntegrationInitialSyncAbort" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeonIntegrationInitialSyncAbortMutation,
  LeonIntegrationInitialSyncAbortMutationVariables
>
export const LeonIntegrationIncrementalSyncStartDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LeonIntegrationIncrementalSyncStart" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leonIntegrationIncrementalSyncStart" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeonIntegrationIncrementalSyncStartMutation,
  LeonIntegrationIncrementalSyncStartMutationVariables
>
export const LeonIntegrationGetTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LeonIntegrationGetToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryLeonIntegrationGetTokenInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leonIntegrationGetToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "refreshToken" } },
                { kind: "Field", name: { kind: "Name", value: "operatorId" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "lastUsedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastSyncDate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "RFC3339" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeonIntegrationGetTokenQuery,
  LeonIntegrationGetTokenQueryVariables
>
export const LeonIntegrationGetEventsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LeonIntegrationGetEvents" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryLeonIntegrationGetEventsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leonIntegrationGetEvents" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "event" } },
                { kind: "Field", name: { kind: "Name", value: "after" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "time" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "RFC3339" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeonIntegrationGetEventsQuery,
  LeonIntegrationGetEventsQueryVariables
>
export const LeonIntegrationInitialSyncLockDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LeonIntegrationInitialSyncLock" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "leonIntegrationInitialSyncLock" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LeonIntegrationInitialSyncLockQuery,
  LeonIntegrationInitialSyncLockQueryVariables
>
export const PresetsGetDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PresetsGet" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationPresetsGetInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "presetsGet" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "organizationId" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "initial" } },
                { kind: "Field", name: { kind: "Name", value: "distance" } },
                { kind: "Field", name: { kind: "Name", value: "fuel" } },
                { kind: "Field", name: { kind: "Name", value: "weight" } },
                { kind: "Field", name: { kind: "Name", value: "temperature" } },
                { kind: "Field", name: { kind: "Name", value: "pressure" } },
                { kind: "Field", name: { kind: "Name", value: "decimalSeparator" } },
                { kind: "Field", name: { kind: "Name", value: "thousandsSeparator" } },
                { kind: "Field", name: { kind: "Name", value: "dateFormat" } },
                { kind: "Field", name: { kind: "Name", value: "timeFormat" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PresetsGetMutation, PresetsGetMutationVariables>
export const PresetsUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PresetsUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationPresetsUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "presetsUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "organizationId" } },
                { kind: "Field", name: { kind: "Name", value: "userId" } },
                { kind: "Field", name: { kind: "Name", value: "initial" } },
                { kind: "Field", name: { kind: "Name", value: "distance" } },
                { kind: "Field", name: { kind: "Name", value: "fuel" } },
                { kind: "Field", name: { kind: "Name", value: "weight" } },
                { kind: "Field", name: { kind: "Name", value: "temperature" } },
                { kind: "Field", name: { kind: "Name", value: "pressure" } },
                { kind: "Field", name: { kind: "Name", value: "decimalSeparator" } },
                { kind: "Field", name: { kind: "Name", value: "thousandsSeparator" } },
                { kind: "Field", name: { kind: "Name", value: "dateFormat" } },
                { kind: "Field", name: { kind: "Name", value: "timeFormat" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PresetsUpdateMutation, PresetsUpdateMutationVariables>
export const UserImageUploadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UserImageUpload" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationPublicFileUploadInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publicFileUpload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserImageUploadMutation, UserImageUploadMutationVariables>
export const UserUpdateImageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UserUpdateImage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationUserUpdateImageInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "userUpdateImage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "image" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserUpdateImageMutation, UserUpdateImageMutationVariables>
export const OrganizationLogoUploadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrganizationLogoUpload" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationPublicFileUploadInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publicFileUpload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrganizationLogoUploadMutation,
  OrganizationLogoUploadMutationVariables
>
export const OrganizationUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OrganizationUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MutationOrganizationUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "logo" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrganizationUpdateMutation,
  OrganizationUpdateMutationVariables
>
export const AircraftNameDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AircraftName" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "QueryAircraftByIdInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "aircraftById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "tail" } },
                { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
                { kind: "Field", name: { kind: "Name", value: "model" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AircraftNameQuery, AircraftNameQueryVariables>
export const FetchUserInfo_MeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchUserInfo_Me" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "me" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MeLoggedIn" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "fetchUserInfo_MeLoggedIn" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MeNotLoggedIn" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "fetchUserInfo_User" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "User" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "emailVerified" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "image" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "fetchUserInfo_Organization" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Organization" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "logo" } },
          { kind: "Field", name: { kind: "Name", value: "metadata" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "fetchUserInfo_MeLoggedIn" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MeLoggedIn" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "isLoggedIn" } },
          { kind: "Field", name: { kind: "Name", value: "activeInvite" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "fetchUserInfo_User" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "fetchUserInfo_Organization" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchUserInfo_MeQuery, FetchUserInfo_MeQueryVariables>
export const OrganizationEventsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "OrganizationEvents" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationEvents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "event" } },
                { kind: "Field", name: { kind: "Name", value: "payload" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrganizationEventsSubscription,
  OrganizationEventsSubscriptionVariables
>
export const HealthcheckDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Healthcheck" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [{ kind: "Field", name: { kind: "Name", value: "healthcheck" } }],
      },
    },
  ],
} as unknown as DocumentNode<HealthcheckQuery, HealthcheckQueryVariables>
